function isStrictComparable(e){return e===e&&!isObject(e)}var isObject=require("./isObject");module.exports=isStrictComparable;